import { render, staticRenderFns } from "./resources-inactive.component.html?vue&type=template&id=4e0d1d84&scoped=true&"
import script from "./resources-inactive.component.ts?vue&type=script&lang=ts&"
export * from "./resources-inactive.component.ts?vue&type=script&lang=ts&"
import style0 from "./resources-inactive.component.scss?vue&type=style&index=0&id=4e0d1d84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0d1d84",
  null
  
)

export default component.exports